import * as ACTION_TYPES from '../subtype/Types'

const initialState = {
    message: "",
    error: null,
    subtypeList: { recordsTotal: 0 },
    subType: {},
    page: 1,
    limit: 10,
}

export const SubtypeReducer = (state = initialState, action) => {
    switch (action.type) {
        case ACTION_TYPES.FETCH_SUBTYPE_SUCCESS:
            return {
                ...state,
                subtypeList: action.payload.data,
                message: action.payload.message,
                error: null
            }
        case ACTION_TYPES.SUBTYPE_PAGE_CHANGE:
            return {
                ...state,
                page: action.payload
            }
        case ACTION_TYPES.SUBTYPE_LIMIT_CHANGE:
            return {
                ...state,
                limit: action.payload
            }
        case ACTION_TYPES.FETCH_SUBTYPE_INFO_SUCCESS:
            return {
                ...state,
                subType: action.payload.data,
                message: action.payload.message,
                isEdited: false,
                error: null
            }
            case ACTION_TYPES.FETCH_SUBTYPE_INFO_ERROR:
                return {
                    ...state,
                    subType: null,
                    message: action.payload.data.message,
                    error: action.payload.data.message
                }
        case ACTION_TYPES.EDIT_SUBTYPE_SUCCESS:
            return {
                ...state,
                subType: action.payload.data,
                message: action.payload.message,
                isEdited: true,
                error: null
            }
        case ACTION_TYPES.FETCH_SUBTYPE_ERROR:
            return {
                ...state,
                message: action.payload.data.message,
                error: action.payload.data.message,
                isEdited: false
            }
        case ACTION_TYPES.EDIT_SUBTYPE_ERROR:
            return {
                ...state,
                message: action.payload.data.message,
                error: action.payload.data.message,
                isEdited: false
            }
        default:
            return state
    }
}